import styled from 'styled-components'

import { ButtonIcon, tokens } from '@arvoreeducacao/bonsai-ds'

export const ContentButton = styled.div<{ hasText: boolean }>`
  display: flex;
  justify-content: start;
  align-items: center;
  cursor: pointer;
  ${({ hasText }) =>
    hasText &&
    `
    padding: ${tokens.spacing.verticalXxsmall} 0;
    border-bottom: 1px solid ${tokens.colors.dark1};
  `}
  > span {
    font-size: ${({ hasText }) =>
      hasText ? tokens.fontSize.medium : tokens.fontSize.xlarge};
  }
`

export const ButtonFavorite = styled(ButtonIcon)<{
  isFavorite: boolean
  noBorder: boolean
}>`
  background: ${props => props.noBorder && 'none'} !important;
  border: ${props => props.noBorder && 'none'};
  margin-left: ${props => props.noBorder && '1px'};
  margin-right: ${props =>
    props.noBorder ? '1px' : tokens.spacing.verticalXsmall};
  padding: ${({ noBorder }) =>
    noBorder
      ? `0px ${tokens.spacing.horizontalSmall} 0px ${tokens.spacing.horizontalMedium}`
      : tokens.spacing.verticalMedium};
  span {
    color: ${({ isFavorite }) =>
      isFavorite ? tokens.colors.livros : tokens.colors.dark5};
  }

  &:hover {
    border: ${props => props.noBorder === true && 'none'};
    span {
      color: ${({ isFavorite }) =>
        isFavorite ? tokens.colors.livros : tokens.colors.dark6};
    }
  }
`
export const Text = styled.span`
  color: ${tokens.colors.dark5};
  font-style: normal;
  font-weight: normal;
  font-size: ${tokens.fontSize.medium};
  line-height: ${tokens.lineHeight.small}%;
  width: 100%;
  display: block;
  transition: color ${tokens.transitions.default};
`
